import {useIntl} from 'react-intl';

import {PencilIcon} from 'packages/ui-kit/src/icons/pencil';

import {getDateTimeForTimezone, getCurrentDateTimeForTimezone, isSameDay, isWithinLastWeek, isYesterday} from 'utils/datetime';
import OverlayTrigger from '../../overlay_trigger';
import Tooltip from '../../tooltip';

import {Props} from './index';

const PostEditedIndicator = ({postId, isMilitaryTime, timeZone, editedAt = 0}: Props): JSX.Element | null => {
    const {formatMessage, formatDate, formatTime} = useIntl();

    if (!postId || editedAt === 0) {
        return null;
    }

    const editedDate = getDateTimeForTimezone(editedAt, timeZone);

    let date;
    switch (true) {
    case isSameDay(editedDate, getCurrentDateTimeForTimezone()):
        date = formatMessage({id: 'datetime.today', defaultMessage: 'today '});
        break;
    case isYesterday(editedDate):
        date = formatMessage({id: 'datetime.yesterday', defaultMessage: 'yesterday '});
        break;
    case isWithinLastWeek(editedDate):
        date = formatDate(editedDate, {weekday: 'long'});
        break;
    case !isWithinLastWeek(editedDate):
    default:
        date = formatDate(editedDate, {month: 'long', day: 'numeric'});
    }

    const time = formatTime(editedDate, {hour: 'numeric', minute: '2-digit', hour12: !isMilitaryTime});

    const editedText = formatMessage({
        id: 'post_message_view.edited',
        defaultMessage: 'Edited',
    });

    const formattedTime = formatMessage({
        id: 'timestamp.datetime',
        defaultMessage: '{relativeOrDate} at {time}',
    },
    {
        relativeOrDate: date,
        time,
    });

    const tooltip = (
        <Tooltip
            id={`edited-post-tooltip_${postId}`}
            className='hidden-xs'
        >
            {`${editedText} ${formattedTime}`}
        </Tooltip>
    );

    return !postId || editedAt === 0 ? null : (
        <OverlayTrigger
            delayShow={250}
            placement='top'
            overlay={tooltip}
        >
            <span
                id={`postEdited_${postId}`}
                className='post-edited__indicator'
                data-post-id={postId}
                data-edited-at={editedAt}
            >
                <PencilIcon width={12} height={12} />
                {editedText}
            </span>
        </OverlayTrigger>
    );
};

export default PostEditedIndicator;
